module.exports = new __parcel__URL__("CanadaEnergyFunding.536c7421.png").toString();